<div class="container-fluid search">
  <div class="row">
    <div class="col-md-12">
      <input id="movil-search" type="text" (keyup)="searchIt($event)" />
      <img (click)="closeSearch()" src="/icons/close.svg" alt="" />
    </div>
  </div>
</div>
